import Bus from '@/bus';
import { LANGUAGE_STORAGE } from '@/constants';
import { getActiveRole, getStoredAuthorization } from '@/Helpers/auth';
import storage from '@/Helpers/storage';
import TokenModel from '@/Models/TokenModel';
import moment from 'moment';
import config from '@/config';

export const RequestAuthInterceptor = conf => {
  if (conf.url === config.tokenUri) {
    return conf;
  }

  let authData = getStoredAuthorization();

  if (!authData) {
    return conf;
  }

  authData = new TokenModel(authData);
  const activeLanguage = storage.get(LANGUAGE_STORAGE) || 'sv';

  const tokenExpiryDate = moment(authData['.expires']);
  const minutesUntilTokenExpiration = tokenExpiryDate.diff(moment(), 'minutes');

  if (minutesUntilTokenExpiration < 5) {
    Bus.$emit('refresh-token');
  }

  conf.headers = {
    Authorization: `${authData.token_type} ${authData.access_token}`,
    'X-OrganizationId': authData.organization,
    'X-GroupId': authData.group,
    'X-RoleId': getActiveRole(),
    'X-LanguageId': activeLanguage
  };

  return conf;
};
